import React from 'react';
import { Instagram, Mail } from 'lucide-react';

const Header = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="!font-bold !text-2xl text-slate-900">
              Aureon<span className="text-blue-600">Media</span>
            </h1>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('what-we-do')}
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors">

              What We Do
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors">

              How It Works
            </button>
            <button
              onClick={() => scrollToSection('revenue-model')}
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors">

              Revenue Model
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors">

              FAQ
            </button>
            <button
              onClick={() => scrollToSection('application-form')}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md font-semibold transition-all duration-300 hover:scale-105">

              Apply Now
            </button>
          </nav>
        </div>
      </div>
    </header>);

};

export default Header;